<template>
  <v-card flat>
    <v-card-title>
      <h3>{{ $t('booking_templates.title') }}</h3>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
          <v-switch
            v-model="customHtml"
            :label="$t('companies.custom_html_template')"
            @change="toggleCustomHtml"
            hide-details
          ></v-switch>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="selectedLang"
            :items="availableLanguages"
            :label="$t('companies.template_lang')"
            dense
            outlined
            hide-details
            @change="loadTemplates"
          ></v-select>
        </v-col>
        <!-- Available Variables -->
        <v-col cols="12">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                  <p class="subheader-1">
                  {{ $t("email_templates.variables_and_tags") }}
                  </p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                  <!-- <p>{{ $t("booking_messages.html_avelable_text") }}</p> -->
                  <code>{{ "{" + "{" + "name" + "}" + "}" }}</code> -
                  {{ $t("email_templates.client_name") }},<br />
                  <code>{{ "{" + "{" + "lastname" + "}" + "}" }}</code>
                  - {{ $t("email_templates.lastname") }},<br />
                  <code>{{
                  "{" + "{" + "middlename" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.middlename") }},<br />
                  <code>{{
                  "{" + "{" + "booking_id" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.booking_id") }},<br />
                  <code>{{
                  "{" + "{" + "start_date" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.start_date") }},<br />
                  <code>{{ "{" + "{" + "end_date" + "}" + "}" }}</code>
                  - {{ $t("email_templates.end_date") }},<br />
                  <code>{{
                  "{" + "{" + "location_start" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.location_start") }},<br />
                  <code>{{
                  "{" + "{" + "location_end" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.location_end") }},<br />
                  <code>{{ "{" + "{" + "car_name" + "}" + "}" }}</code>
                  - {{ $t("email_templates.car_name") }},<br />
                  <code>{{ "{" + "{" + "days" + "}" + "}" }}</code> -
                  {{ $t("email_templates.days") }},<br />
                  <code>{{ "{" + "{" + "price" + "}" + "}" }}</code> -
                  {{ $t("email_templates.price") }},<br />
                  <code>{{ "{" + "{" + "total" + "}" + "}" }}</code> -
                  {{ $t("email_templates.total") }},<br />
                  <code>{{ "{" + "{" + "deposit" + "}" + "}" }}</code> -
                  {{ $t("email_templates.deposit") }},<br />
                  <code>{{
                  "{" + "{" + "company_name" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.company_name") }},<br />
                  <code>{{
                  "{" + "{" + "company_email" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.company_email") }},<br />
                  <code>{{
                  "{" + "{" + "company_phone" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.company_phone") }},<br />
                  <code>{{
                  "{" + "{" + "company_address" + "}" + "}"
                  }}</code>
                  - {{ $t("email_templates.company_address") }}
              </v-expansion-panel-content>
              </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-alert type="info" text class="mt-4" v-if="templates.length === 0">
        {{ $t('booking_templates.no_templates') }}
      </v-alert>

      <!-- Подтверждение и отказ -->
      <h3 class="mt-4 mb-2">{{ $t('booking_templates.confirmation_and_rejection') }}</h3>

      <v-expansion-panels v-model="confirmationPanels" multiple class="mt-2">
        <!-- Подтверждение бронирования -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-chip color="success" dark small class="mr-2">
                {{ $t('booking_templates.accept_message') }}
              </v-chip>
              <span class="grey--text text--darken-1">
                {{ selectedLang || $t('companies.default_lang') }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <h4 v-if="!customHtml">{{ $t('booking_templates.email_content') }}</h4>
                  <v-textarea
                    v-if="customHtml"
                    v-model="acceptEmailContent"
                    :label="$t('booking_templates.email_content')"
                    auto-grow
                    outlined
                    rows="6"
                  ></v-textarea>
                  <div v-else class="tiptap-wrapper">
                    <TiptapEditor v-model="acceptEmailContent" />
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="acceptWhatsappContent"
                    :label="$t('booking_templates.whatsapp_content')"
                    auto-grow
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveAcceptTemplate()"
                    :loading="savingAccept"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Отказ в бронировании -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center">
              <v-chip color="error" dark small class="mr-2">
                {{ $t('booking_templates.decline_message') }}
              </v-chip>
              <span class="grey--text text--darken-1">
                {{ selectedLang || $t('companies.default_lang') }}
              </span>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <h4 v-if="!customHtml">{{ $t('booking_templates.email_content') }}</h4>
                  <v-textarea
                    v-if="customHtml"
                    v-model="declineEmailContent"
                    :label="$t('booking_templates.email_content')"
                    auto-grow
                    outlined
                    rows="6"
                  ></v-textarea>
                  <div v-else class="tiptap-wrapper">
                    <TiptapEditor v-model="declineEmailContent" />
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="declineWhatsappContent"
                    :label="$t('booking_templates.whatsapp_content')"
                    auto-grow
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveDeclineTemplate()"
                    :loading="savingDecline"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Сообщения о начале и окончании бронирования -->
      <h3 class="mt-6 mb-2">{{ $t('booking_templates.start_end_notifications') }}</h3>

      <v-expansion-panels v-model="notificationPanels" multiple class="mt-2">
        <!-- Уведомление о начале бронирования по Email -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center justify-space-between" style="width: 100%;">
              <div class="d-flex align-center">
                <v-switch
                  v-model="sendStartBooking"
                  @click.stop
                  @change="saveCompanySetting('send_start_booking', $event)"
                  hide-details
                  class="mt-0 mr-2"
                ></v-switch>
                <v-chip color="primary" dark small class="mr-2">
                  {{ $t('booking_templates.start_message_email') }}
                </v-chip>
                <span class="grey--text text--darken-1">
                  {{ selectedLang || $t('companies.default_lang') }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <h4 v-if="!customHtml">{{ $t('booking_templates.email_content') }}</h4>
                  <v-textarea
                    v-if="customHtml"
                    v-model="startEmailContent"
                    :label="$t('booking_templates.email_content')"
                    auto-grow
                    outlined
                    rows="6"
                  ></v-textarea>
                  <div v-else class="tiptap-wrapper">
                    <TiptapEditor v-model="startEmailContent" />
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveStartEmailTemplate()"
                    :loading="savingStartEmail"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Уведомление о начале бронирования по WhatsApp -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center justify-space-between" style="width: 100%;">
              <div class="d-flex align-center">
                <v-switch
                  v-model="sendStartBookingWhatsapp"
                  @click.stop
                  @change="saveCompanySetting('send_start_booking_whatsapp', $event)"
                  hide-details
                  class="mt-0 mr-2"
                ></v-switch>
                <v-chip color="success" dark small class="mr-2">
                  {{ $t('booking_templates.start_message_whatsapp') }}
                </v-chip>
                <span class="grey--text text--darken-1">
                  {{ selectedLang || $t('companies.default_lang') }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="startWhatsappContent"
                    :label="$t('booking_templates.whatsapp_content')"
                    auto-grow
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveStartWhatsappTemplate()"
                    :loading="savingStartWhatsapp"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Уведомление об окончании бронирования по Email -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center justify-space-between" style="width: 100%;">
              <div class="d-flex align-center">
                <v-switch
                  v-model="sendEndBooking"
                  @click.stop
                  @change="saveCompanySetting('send_end_booking', $event)"
                  hide-details
                  class="mt-0 mr-2"
                ></v-switch>
                <v-chip color="orange" dark small class="mr-2">
                  {{ $t('booking_templates.end_message_email') }}
                </v-chip>
                <span class="grey--text text--darken-1">
                  {{ selectedLang || $t('companies.default_lang') }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <h4 v-if="!customHtml">{{ $t('booking_templates.email_content') }}</h4>
                  <v-textarea
                    v-if="customHtml"
                    v-model="endEmailContent"
                    :label="$t('booking_templates.email_content')"
                    auto-grow
                    outlined
                    rows="6"
                  ></v-textarea>
                  <div v-else class="tiptap-wrapper">
                    <TiptapEditor v-model="endEmailContent" />
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveEndEmailTemplate()"
                    :loading="savingEndEmail"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Уведомление об окончании бронирования по WhatsApp -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center justify-space-between" style="width: 100%;">
              <div class="d-flex align-center">
                <v-switch
                  v-model="sendEndBookingWhatsapp"
                  @click.stop
                  @change="saveCompanySetting('send_end_booking_whatsapp', $event)"
                  hide-details
                  class="mt-0 mr-2"
                ></v-switch>
                <v-chip color="pink" dark small class="mr-2">
                  {{ $t('booking_templates.end_message_whatsapp') }}
                </v-chip>
                <span class="grey--text text--darken-1">
                  {{ selectedLang || $t('companies.default_lang') }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="endWhatsappContent"
                    :label="$t('booking_templates.whatsapp_content')"
                    auto-grow
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveEndWhatsappTemplate()"
                    :loading="savingEndWhatsapp"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Напоминания об отзыве -->
      <h3 class="mt-6 mb-2">{{ $t('booking_templates.review_reminders') }}</h3>

      <v-expansion-panels v-model="reviewPanels" multiple class="mt-2">
        <!-- Напоминание об отзыве по Email -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center justify-space-between" style="width: 100%;">
              <div class="d-flex align-center">
                <v-switch
                  v-model="sendReviewReminder"
                  @click.stop
                  @change="saveCompanySetting('send_review_reminder', $event)"
                  hide-details
                  class="mt-0 mr-2"
                ></v-switch>
                <v-chip color="purple" dark small class="mr-2">
                  {{ $t('booking_templates.review_message_email') }}
                </v-chip>
                <span class="grey--text text--darken-1">
                  {{ selectedLang || $t('companies.default_lang') }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <h4 v-if="!customHtml">{{ $t('booking_templates.email_content') }}</h4>
                  <v-textarea
                    v-if="customHtml"
                    v-model="reviewEmailContent"
                    :label="$t('booking_templates.email_content')"
                    auto-grow
                    outlined
                    rows="6"
                  ></v-textarea>
                  <div v-else class="tiptap-wrapper">
                    <TiptapEditor v-model="reviewEmailContent" />
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveReviewEmailTemplate()"
                    :loading="savingReviewEmail"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <!-- Напоминание об отзыве по WhatsApp -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="d-flex align-center justify-space-between" style="width: 100%;">
              <div class="d-flex align-center">
                <v-switch
                  v-model="sendReviewReminderWhatsapp"
                  @click.stop
                  @change="saveCompanySetting('send_review_reminder_whatsapp', $event)"
                  hide-details
                  class="mt-0 mr-2"
                ></v-switch>
                <v-chip color="deep-purple" dark small class="mr-2">
                  {{ $t('booking_templates.review_message_whatsapp') }}
                </v-chip>
                <span class="grey--text text--darken-1">
                  {{ selectedLang || $t('companies.default_lang') }}
                </span>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="reviewWhatsappContent"
                    :label="$t('booking_templates.whatsapp_content')"
                    auto-grow
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row class="mt-2">
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="success"
                    @click="saveReviewWhatsappTemplate()"
                    :loading="savingReviewWhatsapp"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    {{ $t('custom.save_template') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import TiptapEditor from '@/components/common/TiptapEditor.vue';

export default {
  name: 'BookingMessageTemplates',
  
  components: {
    TiptapEditor,
  },
  
  data() {
    return {
      templates: [],
      openPanels: [],
      confirmationPanels: [],
      notificationPanels: [],
      reviewPanels: [],
      customHtml: false,
      selectedLang: null,
      availableLanguages: [
        { text: this.$t("companies.default_lang"), value: null },
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      // Шаблоны подтверждения/отказа
      acceptEmailContent: '',
      acceptWhatsappContent: '',
      declineEmailContent: '',
      declineWhatsappContent: '',
      // Шаблоны начала/окончания
      startEmailContent: '',
      startWhatsappContent: '',
      endEmailContent: '',
      endWhatsappContent: '',
      // Шаблоны напоминания об отзыве
      reviewEmailContent: '',
      reviewWhatsappContent: '',
      // Флаги включения/выключения уведомлений (из company)
      sendStartBooking: false,
      sendStartBookingWhatsapp: false,
      sendEndBooking: false,
      sendEndBookingWhatsapp: false,
      sendReviewReminder: false,
      sendReviewReminderWhatsapp: false,
      // Флаги загрузки
      savingAccept: false,
      savingDecline: false,
      savingStartEmail: false,
      savingStartWhatsapp: false,
      savingEndEmail: false,
      savingEndWhatsapp: false,
      savingReviewEmail: false,
      savingReviewWhatsapp: false,
    };
  },

  computed: {
    company() {
      const storeCompany = this.$store.getters.getCompany;
      // Store хранит company как { company: {...} }
      return storeCompany?.company || storeCompany;
    }
  },

  mounted() {
    this.loadTemplates();
    this.loadCompanySettings();
  },

  methods: {
    loadCompanySettings() {
      if (this.company) {
        this.sendStartBooking = this.company.send_start_booking || false;
        this.sendStartBookingWhatsapp = this.company.send_start_booking_whatsapp || false;
        this.sendEndBooking = this.company.send_end_booking || false;
        this.sendEndBookingWhatsapp = this.company.send_end_booking_whatsapp || false;
        this.sendReviewReminder = this.company.send_review_reminder || false;
        this.sendReviewReminderWhatsapp = this.company.send_review_reminder_whatsapp || false;
      }
    },

    loadTemplates() {
      this.axios.get(`/api/v1/company/booking_messages_with_lang/${this.selectedLang}`, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then((response) => {
          if (response.data) {
            // Set custom_html mode
            if (response.data.custom_html !== undefined) {
              this.customHtml = response.data.custom_html;
            } else {
              this.customHtml = this.selectedLang ? true : false;
            }

            // Подтверждение/Отказ
            this.acceptEmailContent = response.data.accept_message || '';
            this.acceptWhatsappContent = response.data.accept_whatsapp || '';
            this.declineEmailContent = response.data.decline_message || '';
            this.declineWhatsappContent = response.data.decline_whatsapp || '';
            
            // Начало/Окончание
            this.startEmailContent = response.data.start_message || '';
            this.startWhatsappContent = response.data.start_message_whatsapp || '';
            this.endEmailContent = response.data.end_message || '';
            this.endWhatsappContent = response.data.end_message_whatsapp || '';
            
            // Напоминание об отзыве
            this.reviewEmailContent = response.data.review_email || '';
            this.reviewWhatsappContent = response.data.review_whatsapp || '';

            // Build templates array (for backward compatibility)
            this.templates = [
              {
                type: 'accept_message',
                emailContent: response.data.accept_message || '',
                whatsappContent: response.data.accept_whatsapp || '',
                lang: this.selectedLang,
                saving: false
              },
              {
                type: 'decline_message',
                emailContent: response.data.decline_message || '',
                whatsappContent: response.data.decline_whatsapp || '',
                lang: this.selectedLang,
                saving: false
              },
              {
                type: 'start_message',
                emailContent: response.data.start_message || '',
                whatsappContent: response.data.start_message_whatsapp || '',
                lang: this.selectedLang,
                saving: false
              },
              {
                type: 'end_message',
                emailContent: response.data.end_message || '',
                whatsappContent: response.data.end_message_whatsapp || '',
                lang: this.selectedLang,
                saving: false
              },
              {
                type: 'review_message',
                emailContent: response.data.review_email || '',
                whatsappContent: response.data.review_whatsapp || '',
                lang: this.selectedLang,
                saving: false
              },
            ];
          }
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        });
    },

    toggleCustomHtml() {
      // When toggling custom_html, save it immediately
      this.updateAllTemplates();
    },

    saveCompanySetting(field, value) {
      const payload = {
        company: {
          [field]: value
        }
      };

      this.axios.patch('/api/v1/company', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then((response) => {
          this.$store.commit("setCompany", { company: response.data });
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        });
    },

    saveAcceptTemplate() {
      this.savingAccept = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          accept_message: this.acceptEmailContent,
          accept_whatsapp: this.acceptWhatsappContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingAccept = false;
        });
    },

    saveDeclineTemplate() {
      this.savingDecline = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          decline_message: this.declineEmailContent,
          decline_whatsapp: this.declineWhatsappContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingDecline = false;
        });
    },

    saveStartEmailTemplate() {
      this.savingStartEmail = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          start_message: this.startEmailContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingStartEmail = false;
        });
    },

    saveStartWhatsappTemplate() {
      this.savingStartWhatsapp = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          start_message_whatsapp: this.startWhatsappContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingStartWhatsapp = false;
        });
    },

    saveEndEmailTemplate() {
      this.savingEndEmail = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          end_message: this.endEmailContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingEndEmail = false;
        });
    },

    saveEndWhatsappTemplate() {
      this.savingEndWhatsapp = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          end_message_whatsapp: this.endWhatsappContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingEndWhatsapp = false;
        });
    },

    saveReviewEmailTemplate() {
      this.savingReviewEmail = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          review_email: this.reviewEmailContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingReviewEmail = false;
        });
    },

    saveReviewWhatsappTemplate() {
      this.savingReviewWhatsapp = true;
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          review_whatsapp: this.reviewWhatsappContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then(() => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          this.savingReviewWhatsapp = false;
        });
    },

    updateTemplate(template) {
      template.saving = true;
      
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
        }
      };

      // Map template type to API field names
      const fieldMapping = {
        accept_message: { email: 'accept_message', whatsapp: 'accept_whatsapp' },
        decline_message: { email: 'decline_message', whatsapp: 'decline_whatsapp' },
        start_message: { email: 'start_message', whatsapp: 'start_message_whatsapp' },
        end_message: { email: 'end_message', whatsapp: 'end_message_whatsapp' },
        review_message: { email: 'review_email', whatsapp: 'review_whatsapp' },
      };

      const fields = fieldMapping[template.type];
      if (fields) {
        payload.booking_message[fields.email] = template.emailContent;
        payload.booking_message[fields.whatsapp] = template.whatsappContent;
      }

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then((response) => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        })
        .finally(() => {
          template.saving = false;
        });
    },

    updateAllTemplates() {
      // Send all templates data when toggling custom_html
      const payload = {
        booking_message: {
          custom_html: this.customHtml,
          lang: this.selectedLang,
          accept_message: this.acceptEmailContent,
          accept_whatsapp: this.acceptWhatsappContent,
          decline_message: this.declineEmailContent,
          decline_whatsapp: this.declineWhatsappContent,
          start_message: this.startEmailContent,
          start_message_whatsapp: this.startWhatsappContent,
          end_message: this.endEmailContent,
          end_message_whatsapp: this.endWhatsappContent,
          review_email: this.reviewEmailContent,
          review_whatsapp: this.reviewWhatsappContent,
        }
      };

      this.axios.post('/api/v1/company/booking_message', payload, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
        .then((response) => {
          this.$notify(this.$t('custom.saved'), '', 'success', 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t('errors.error'));
        });
    },

    getTemplateColor(type) {
      const colors = {
        accept_message: 'success',
        decline_message: 'error',
        start_message: 'primary',
        end_message: 'orange',
        review_message: 'purple',
      };
      return colors[type] || 'grey';
    },

  },

  watch: {
    company: {
      handler(newVal) {
        if (newVal) {
          this.loadCompanySettings();
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.tiptap-wrapper {
  margin: 10px 0;
}
/* xs: строки заголовков панелей (switch + chip + язык) шире экрана.
   Тумблер и чип — в одной строке (чип ужимается до доступной ширины и
   переносит текст), подпись языка — своей строкой ниже. */
@media (max-width: 599px) {
  ::v-deep .v-expansion-panel-header .d-flex {
    flex-wrap: wrap;
    row-gap: 4px;
    min-width: 0;
  }
  ::v-deep .v-expansion-panel-header .v-chip {
    flex: 1 1 0;
    max-width: max-content;
    height: auto;
    min-height: 24px;
    white-space: normal;
  }
  ::v-deep .v-expansion-panel-header .v-chip .v-chip__content {
    white-space: normal;
    overflow-wrap: anywhere;
    padding-top: 2px;
    padding-bottom: 2px;
  }
  /* именно текст «язык шаблонов» (v-chip — тоже span, его не трогаем) */
  ::v-deep .v-expansion-panel-header .d-flex > span.grey--text {
    flex-basis: 100%;
  }
  ::v-deep .v-expansion-panel-header .v-input--switch {
    flex: 0 0 auto;
    margin-bottom: 0;
    padding-top: 0;
  }
}
</style>

